import { ReactComponent as OnestepIcon } from '../../../../assets/icons/timeline/onestep.svg';
import { getDate, formatTime } from '../../../../services/timeService';
import { dateTimeFormat } from '../../../../services/timeService/types';
import useCareLogService from '../../../../services/careLogService';

export default function useFirstLoginEvent(patientUuid: string) {
  const { firstLogin } = useCareLogService(patientUuid);

  if (!firstLogin) {
    return null;
  }
  const momentTime = getDate(firstLogin);
  const formatedTime = momentTime
    ? formatTime(momentTime, dateTimeFormat.SERVER_DATE_FORMAT)
    : 0;
  return {
    name: 'First application login',
    date: formatedTime,
    icon: OnestepIcon,
    description: `${formatTime(momentTime)}, ${momentTime.fromNow()}`,
  };
}
